import React, { Suspense, lazy } from 'react';
import './styles/theme.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
import Services from './components/Services/Services';
import Sectors from './components/Sectors/Sectors';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import MatrixBackground from './components/MatrixBackground/MatrixBackground';

// Carga diferida del hero 3D (Three.js) para no inflar el bundle inicial.
const Hero3D = lazy(() => import('./components/Hero3D/Hero3D'));

// Placeholder mientras carga Three.js: mismo fondo, sin salto visual.
const Hero3DFallback = () => (
  <div
    style={{
      width: '100%',
      height: '100svh',
      minHeight: 520,
      background:
        'radial-gradient(circle at 50% 42%, #0a1410 0%, #04070a 58%, #010204 100%)',
    }}
  />
);

function App() {
  return (
    <div className="App">
      <MatrixBackground />
      <Header />
      <Suspense fallback={<Hero3DFallback />}>
        <Hero3D />
      </Suspense>
      <Hero />
      <About />
      <Projects />
      <Services />
      <Sectors />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
